( function( $, moment ) {
    "use strict";

    var _events = {
        onChangeType: function() {
            $(this).closest('[data-form-field="booking-type"]').trigger('refresh');
        },

        onRefreshType: function() {
            var $typeField = $(this),
                $typeInputs = $typeField.find('input[name][type="radio"]'),
                $locationField = $('[data-form-field="booking-location"]'),
                $allowScheduleConflictField = $('[data-form-field="booking-allow_schedule_conflict"]'),
                $artistFeeField = $('[data-form-field="booking-other_fee"]'),
                value = $typeInputs.filter(':checked').val();

            if (-1 !== $.App.instance.options.bookingPublicTypes.indexOf(value)) {
                $locationField.removeClass('hidden');
                $allowScheduleConflictField.removeClass('hidden');
                $artistFeeField.removeClass('hidden');
            } else {
                $locationField.addClass('hidden');
                $allowScheduleConflictField.addClass('hidden');
                $artistFeeField.addClass('hidden');
            }
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $form = $container.find('form[data-form="booking"]'),
            $name = $form.find('[data-form-control="name"]'),
            $typeField = $form.find('[data-form-field="booking-type"]'),
            $typeInputs = $typeField.find('input[name][type="radio"]');

        $typeInputs.on('change', _events.onChangeType);
        $typeField.on('refresh', _events.onRefreshType).trigger('refresh');

        if ($form.data('default-start-date')) {
            var $startDate = $form.find('[data-form-control="start_date"]').first(),
                $startTime = $form.find('[data-form-control="start_time"]').first();

            if (! $startDate.datepicker('getDate') && ! $startTime.timepicker('getTime')) {
                var startDate = new moment($form.data('default-start-date'));

                if (-1 === $form.data('default-start-date').indexOf('T')) {
                    startDate.hours(12);
                }

                $startTime.timepicker('setTime', startDate.toDate());

                $startDate
                    .datepicker('setDate', startDate.toDate())
                    .trigger('focus')
                    .datepicker('hide');

                if (-1 === $form.data('default-start-date').indexOf('T')) {
                    $form.find('[data-form-control="all_day"]').prop('checked', true).trigger('change');
                }
            }
        }

        if ($form.is('[data-form-create]')) {
            $name.focus();
        }

        $('[data-dynamic-height]').dynamicMaxHeight();
    });

}( require('jquery'), require('moment'), require('../scripts/vendor/jquery-dynamic-max-height/jquery.dynamicmaxheight') ));
